import React from "react";
import { TriggerNode } from "./TriggerNode";
import { ActionNode } from "./ActionNode";
import { GhostNode } from "./GhostNode";
import { ConditionNode } from "./ConditionNode";
import { IteratorNode } from "./IteratorNode";
import { ApplicationRecordBatchNode } from "./ApplicationRecordBatchNode";
import { CandidateRecordBatchNode } from "./CandidateRecordBatchNode";
import { ClientRecordBatchNode } from "./ClientRecordBatchNode";
import { ContactRecordBatchNode } from "./ContactRecordBatchNode";
import { CustomEntityRecordBatchNode } from "./CustomEntityRecordBatchNode";
import { JobRecordBatchNode } from "./JobRecordBatchNode";
import { LegacyEntityBatchNode } from "./LegacyEntityBatchNode";
import { DelayNode } from "./DelayNode";
import ButtonEdge from "../edges/ButtonEdge";
import AnimatedEdge from "../edges/AnimatedEdge";

export const createNodeTypes = (
  getHandlers: (id: string) => {
    onAddAction: ({ edgeColor }: { edgeColor?: string }) => void;
    onDelete: () => void;
    onEdit: () => void;
    readOnly: boolean;
    onAddChildAction?: () => void;
  },
) => ({
  trigger: (props: any) => React.createElement(TriggerNode, { ...props, ...getHandlers(props.id) }),
  action: (props: any) => React.createElement(ActionNode, { ...props, ...getHandlers(props.id) }),
  ghost: (props: any) => React.createElement(GhostNode, { ...props, ...getHandlers(props.id) }),
  condition: (props: any) => React.createElement(ConditionNode, { ...props, ...getHandlers(props.id) }),
  iterator: (props: any) => React.createElement(IteratorNode, { ...props, ...getHandlers(props.id) }),
  recordBatch: (props: any) => React.createElement(LegacyEntityBatchNode, { ...props, ...getHandlers(props.id) }),
  candidateRecordBatch: (props: any) =>
    React.createElement(CandidateRecordBatchNode, { ...props, ...getHandlers(props.id) }),
  contactRecordBatch: (props: any) =>
    React.createElement(ContactRecordBatchNode, { ...props, ...getHandlers(props.id) }),
  clientRecordBatch: (props: any) => React.createElement(ClientRecordBatchNode, { ...props, ...getHandlers(props.id) }),
  jobRecordBatch: (props: any) => React.createElement(JobRecordBatchNode, { ...props, ...getHandlers(props.id) }),
  applicationRecordBatch: (props: any) =>
    React.createElement(ApplicationRecordBatchNode, { ...props, ...getHandlers(props.id) }),
  customEntityRecordBatch: (props: any) =>
    React.createElement(CustomEntityRecordBatchNode, { ...props, ...getHandlers(props.id) }),
  delay: (props: any) => React.createElement(DelayNode, { ...props, ...getHandlers(props.id) }),
});

export const edgeTypes = {
  buttonedge: ButtonEdge,
  animated: AnimatedEdge,
};
